import {
  RouterTabbedNavigation as BaseRouterTabbedNavigation,
  type RouterTabbedNavigationProps,
  type TabbedNavigationGroups,
  type TabbedNavigationTab,
} from '@interxfi/app-components/components/router-tabbed-navigation/router-tabbed-navigation';

export enum TabbedNavigationGroup {
  AssetMarketData = 'asset-market-data',
  ClearingComplianceFincen = 'clearing-compliance-fincen',
  ClearingComplianceOfac = 'clearing-compliance-ofac',
  ClearingComplianceReporting = 'clearing-compliance-reporting',
  ClearingFinanceAccounting = 'clearing-finance-accounting',
  ClearingFinanceAccountingCoa = 'clearing-finance-accounting-coa',
  ClearingFinanceMiddleMoney = 'clearing-finance-middle-money',
  ClearingFinancePayments = 'clearing-finance-payments',
  ClearingFinanceJournal = 'clearing-finance-journal',
  ClearingOperationsCore = 'clearing-operations-core',
  ClearingOperationsCorporateActions = 'clearing-operations-corporate-actions',
  ClearingOperationsDtcc = 'clearing-operations-dtcc',
  ClearingOperationsInventory = 'clearing-operations-inventory',
  ClearingOperationsMutualfunds = 'clearing-operations-mutualfunds',
  ClearingOperationsOms = 'clearing-operations-oms',
  ClearingOperationsReporting = 'clearing-operations-reporting',
  ClearingOperationsSweeps = 'clearing-operations-sweeps',
  ClearingOperationsDocGenTradeConfirm = 'clearing-operations-docgen-trade-confirm',
  ClearingOperationsDocGenMonthlyStatement = 'clearing-operations-docgen-monthly-statement',
  ClearingOperationsTrade = 'clearing-operations-trade',
  ClearingVendorBetaNxt = 'clearing-vendor-beta-nxt',
  ClearingVendorBetaNxtProxyVoteJob = 'clearing-vendor-beta-nxt-proxy-vote-job',
  ClearingVendorDtcc = 'clearing-vendor-dtcc',
  ClearingVendorIce = 'clearing-vendor-ice',
  ClearingVendorIncrease = 'clearing-vendor-increase',
  ClearingVendorJpmam = 'clearing-vendor-jpmam',
  ClearingVendorQuoteMedia = 'clearing-vendor-quote-media',
  Registration = 'registration',
  Developers = 'developers',
  Hours = 'hours',
  Organization = 'organization',
  OrdersEquities = 'orders-equities',
  OrdersMutualFunds = 'orders-mutual-funds',
  PlatformUsers = 'platform-users',
  ProgramConfigurationOld = 'program-configuration-old',
  ProgramConfiguration = 'program-configuration',
  RollupFunding = 'rollup-funding',
  RegistrationAccountSummaryList = 'registration-account-summary-list',
  RegistrationAccountCashEquivalents = 'registration-account-cash-equivalents',
  RegistrationAccountPortfolioAssetBalance = 'registration-account-portfolio-asset-balance',
  RegistrationAccountDocuments = 'registration-account-documents',
  RegistrationAccountOverview = 'registration-account-overview',
  Sweeps = 'sweeps',
}

export enum TabbedNavigationSubGroup {
  RegistrationAccountSummaryListOrders = 'registration-account-summary-list-orders',
}

export type PortalTabbedNavigationTab<TGroup extends TabbedNavigationGroup, TSubGroup extends TabbedNavigationSubGroup = never> = TabbedNavigationTab<
  TGroup,
  TSubGroup
>;

export type PortalTabbedNavigationGroups = TabbedNavigationGroups<TabbedNavigationGroup>;

export type PortalRouterTabbedNavigationProps = RouterTabbedNavigationProps<TabbedNavigationGroup>;

// This is just a wrapper to ease refactoring by not requiring generic values
export function RouterTabbedNavigation(props: PortalRouterTabbedNavigationProps) {
  return <BaseRouterTabbedNavigation {...props} />;
}
